import React from 'react';
import PropTypes from 'prop-types';

const AddressView = ({ address, inline }) => {
    const separator = inline ? <span>{', '}</span> : <br />;
    return (
        <address className="m-0 text-dark">
            <strong>{address.name}</strong>{separator}
            {address.street1}{separator}
            {address.street2 && <span>{address.street2}{separator}</span>}
            {address.postalCode} {address.city}{separator}
            {address.country}{!inline && separator}
            {!inline && address.phone}
        </address>
    );
};

AddressView.defaultProps = {
    inline: false,
};

AddressView.propTypes = {
    address: PropTypes.object.isRequired,
    inline: PropTypes.bool,
};

export default AddressView;
